try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import { Section } from '@design-system/section';
import { Typography } from '@design-system/typography';
import { ScreenRecognitionContext } from '@phx-husky/screen-recognition';
import classNames from 'classnames';
import { forwardRef, useState, useContext, useEffect } from 'react';

var InfoBarAction;
(function (InfoBarAction) {
    InfoBarAction["PAUSE"] = "pause";
    InfoBarAction["PLAY"] = "play";
    InfoBarAction["NEXT"] = "next";
    InfoBarAction["PREVIOUS"] = "previous";
})(InfoBarAction || (InfoBarAction = {}));
const InfoBar = forwardRef(({ className, messages, ariaLabels, soloMode = false, intervalTime = 4 }, ref) => {
    const [activeElementIndex, setActiveElementIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const { isMobile } = useContext(ScreenRecognitionContext);
    const changeText = (action) => {
        const messagesKeys = [...messages.keys()];
        const lastElementIndex = messagesKeys[messages.length - 1];
        switch (action) {
            case InfoBarAction.PAUSE:
                setIsPaused(true);
                break;
            case InfoBarAction.PLAY:
                setIsPaused(false);
                break;
            case InfoBarAction.NEXT:
                setActiveElementIndex((prev) => { var _a; return (_a = messagesKeys[prev + 1]) !== null && _a !== void 0 ? _a : 0; });
                break;
            case InfoBarAction.PREVIOUS:
                setActiveElementIndex((prev) => { var _a; return (_a = messagesKeys[prev - 1]) !== null && _a !== void 0 ? _a : lastElementIndex; });
                break;
        }
    };
    const handlePlay = () => {
        changeText(InfoBarAction.PLAY);
    };
    useEffect(() => {
        if (isPaused || messages.length <= 0 || soloMode)
            return undefined;
        const interval = setInterval(() => {
            changeText(InfoBarAction.NEXT);
        }, intervalTime * 1000);
        return () => {
            clearInterval(interval);
        };
    }, [isPaused]);
    const handleNextText = () => {
        changeText(InfoBarAction.NEXT);
    };
    const handlePreviousText = () => {
        changeText(InfoBarAction.PREVIOUS);
    };
    const handlePause = () => {
        changeText(InfoBarAction.PAUSE);
    };
    return (jsx(Section, Object.assign({ "data-testid": "info-bar", ref: ref, element: "aside", removeAllSpacing: true, className: classNames('cds-info-bar', className) }, { children: jsxs("div", Object.assign({ className: "cds-info-bar__container" }, { children: [isMobile && !soloMode && (jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowLeft, onClick: handlePreviousText, id: "btn-info-bar-prev" }, { children: jsx(Icon, { icon: "arrowLeft" }) }))), jsx(Typography, { variant: "body", size: isMobile ? 'xs' : 's', weight: "medium", className: "cds-info-bar__message", content: messages[activeElementIndex].text }), isMobile && !soloMode && (jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowRight, onClick: handleNextText, id: "btn-info-bar-next" }, { children: jsx(Icon, { icon: "arrowRight" }) }))), !isMobile && !soloMode && (jsxs("div", Object.assign({ className: "cds-info-bar__action-icons" }, { children: [jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowLeft, onClick: handlePreviousText, id: "btn-info-bar-prev" }, { children: jsx(Icon, { icon: "arrowLeft" }) })), isPaused ? (jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.play, onClick: handlePlay, id: "btn-play" }, { children: jsx(Icon, { icon: "play" }) }))) : (jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.pause, onClick: handlePause, id: "btn-pause" }, { children: jsx(Icon, { icon: "pause" }) }))), jsx("button", Object.assign({ type: "button", "aria-label": ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.arrowRight, onClick: handleNextText, id: "btn-info-bar-next" }, { children: jsx(Icon, { icon: "arrowRight" }) }))] })))] })) })));
});

export { InfoBar };
